
export enum ChatRoleType {
    USER = "user",
    BOT = "bot"
}

export enum ChatActionType {
    CHAT = "CHAT",
}
